import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'

import config from 'app/requests/User.requests'
import {
    User,
} from '../Users.types'

export default (ids: number[]) => {
    return useRequest<User[]>({
        key: RequestKeys.getUsers,
        params: {
            includeFilters: {
                id: ids,
            },
        },
        requestFunc: RequestFn.getEntity(config.getUsers, (promise) => {
            return promise.then((resp) => {
                return resp?.data?.items
            })
        }),
        keepPreviousData: true,
        enabled: Boolean(ids.length),
    })
}
